import Icon from 'components/core/Icon/Icon'

const prettyPrice = (
  price,
  preferredCurrency = 'MATIC',
  maticToUsdMultiplier = 1,
  descriptive = false
) => {
  if (preferredCurrency === 'USD') {
    // Price in USD
    const outputPrice = price ? price * maticToUsdMultiplier : null

    return (
      <>
        <span className="prpr--val">
          {outputPrice
            ? '$' +
              String((outputPrice || 0).toFixed(outputPrice >= 100 ? 0 : 2)) +
              (descriptive ? ' USD' : '')
            : 'FREE'}
        </span>
      </>
    )
  }

  // Price in POL
  const numPrice = Number(price || 0)
  const numPriceFixed = Number(numPrice.toFixed(2))
  const numPriceOutput =
    numPrice > 0 && numPrice < 0.005 ? '<0.01' : numPriceFixed

  return (
    <>
      {price > 0 && <Icon className="prpr--icon" icon="matic" />}
      <span className="prpr--val">
        {price
          ? String(numPriceOutput + (descriptive ? ' POL' : ''))
          : 'FREE'}
      </span>
    </>
  )
}

export default prettyPrice
